import { failureAction, successAction, startAction } from '../../common'
import {
  ADD_TOURNAMENT_PLAYER,
  UPDATE_TOURNAMENT_PLAYER,
  CANCEL_ADD_TOURNAMENT_PLAYER,
  RESET_ADD_TOURNAMENT_PLAYER,
} from '../types'

export const initialState = {
  saving: false,
  saved: false,
  cancelled: false,
  error: {},
  data: {},
}

const reducer = ({ edit: state }, action) => {
  switch (action.type) {
    case startAction(ADD_TOURNAMENT_PLAYER):
    case startAction(UPDATE_TOURNAMENT_PLAYER):
      return {
        ...state,
        saving: true,
        saved: false,
        error: {},
        data: {},
      }
    case successAction(UPDATE_TOURNAMENT_PLAYER):
    case successAction(ADD_TOURNAMENT_PLAYER):
      return {
        ...state,
        saving: false,
        saved: true,
        error: {},
        data: action.payload,
      }
    case failureAction(UPDATE_TOURNAMENT_PLAYER):
    case failureAction(ADD_TOURNAMENT_PLAYER):
      return {
        ...state,
        saving: false,
        saved: false,
        error: action.payload,
        data: {},
      }

    case CANCEL_ADD_TOURNAMENT_PLAYER:
      return {
        ...state,
        ...initialState,
        cancelled: true,
      }

    case RESET_ADD_TOURNAMENT_PLAYER:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default reducer
